<ion-menu
  menuId="infoMenu"
  side="end"
  type="overlay"
  contentId="infomenuContent"
  (ionWillOpen)="menuWillOpen()"
  swipeGesture="false"
>
  <ion-header>
    <app-modal-header
      [modalTitle]="'Device Info'"
      (closeModal)="closeInfoMenu()"
    ></app-modal-header>
  </ion-header>

  <ion-content mode="ios">
    <div class="content">
      <ion-list lines="full">
        <ion-item>
          <ion-label
            *ngIf="
              sharedDataService.deviceUID &&
              sharedDataService.deviceUID.length > 0
            "
            style="flex: none !important; margin-right: 0 !important"
            slot="start"
          >
            {{ isWebApp ? "Pairing Code" : "UID" }}</ion-label
          >
          <ion-note color="medium" slot="end" class="selectable-text">{{
            UtilService.modifyUDID(sharedDataService.deviceUID)
          }}</ion-note>
        </ion-item>
        <ion-item *ngIf="!isWebApp">
          <ion-label slot="start">Device Status</ion-label>
          <ion-chip *ngIf="isOnline" color="clear" slot="end">
            <ion-icon color="success" name="ellipse"></ion-icon>
            <ion-label color="success">Online</ion-label>
          </ion-chip>

          <ion-chip *ngIf="!isOnline" color="clear" slot="end">
            <ion-icon color="danger" name="ellipse"></ion-icon>
            <ion-label color="danger">Offline</ion-label>
          </ion-chip>
        </ion-item>

        <ion-item *ngIf="!isWebApp">
          <ion-label slot="start">Last Sync</ion-label>
          <ion-note color="medium" *ngIf="lastSyncDateTime">{{
            lastSyncDateTime | date: "dd MMM yyyy HH:mm"
          }}</ion-note>
          <ion-note color="medium" slot="end" *ngIf="!lastSyncDateTime"
            >No synced yet</ion-note
          >
        </ion-item>
      </ion-list>

      <app-sync-warning-msg
        *ngIf="isSycronizationNeeded && !isWebApp"
      ></app-sync-warning-msg>

      <ion-note color="medium" *ngIf="!isWebApp" class="sync-note">
        Synchronisation runs automatically in the background.
      </ion-note>
    </div>
  </ion-content>
</ion-menu>
